import React, { useContext } from "react"
import { FlexRow, FlexCol } from "components/FlexGrid"
import InternalNav from "../InternalNav/InternalNav"
import { InternalWSYSIWG } from "../InternalWSYSIWG"
import { TagFootNote } from "../TagFootNote"
import { RelatedPages } from "../RelatedPages"
import { InternalRHSCTA } from "../InternalRHSCTA"
import InternalRHSTeaser from "../InternalRHSTeaser/InternalRHSTeaser"
import {
  InternalPageContainer,
  InternalFlexGrid,
  RightColumnContainer,
  RHSTeaserCTAContainer,
} from "./style"
import { ThemeContext } from "styled-components"

const InternalPage = ({
  stepByStep,
  checklist,
  currentPageLink,
  ancestors,
  content,
  relatedContent,
  tags,
}) => {
  console.log("tags:", tags)
  const themeContext = useContext(ThemeContext)
  const currentSite = themeContext.site
  const other = currentSite === "other"
  console.log("other:", other)

  return (
    <InternalPageContainer>
      <InternalFlexGrid other={other} gap={[0, 0, 20, 40]} rowGap={[0]}>
        <FlexRow>
          <FlexCol xs={12} md={other ? 12 : 8}>
            <InternalWSYSIWG
              stepByStep={stepByStep}
              checklist={checklist}
              content={content}
              other={other}
            />
          </FlexCol>
          {!other && (
            <FlexCol xs={12} md={4}>
              <RightColumnContainer>
                {ancestors?.length > 0 && (
                  <InternalNav
                    page={2}
                    currentPageLink={currentPageLink}
                    ancestors={ancestors}
                  />
                )}
                <RHSTeaserCTAContainer>
                  {relatedContent?.rhsBanners?.page && (
                    <InternalRHSTeaser data={relatedContent.rhsBanners} />
                  )}
                  {relatedContent?.rhsBanners?.colouredCta &&
                    relatedContent?.rhsBanners?.colouredCta?.title && (
                      <InternalRHSCTA
                        data={relatedContent?.rhsBanners?.colouredCta}
                      />
                    )}
                </RHSTeaserCTAContainer>
              </RightColumnContainer>
            </FlexCol>
          )}
        </FlexRow>
        <FlexRow>
          <FlexCol xs={12} md={8}>
            {tags?.nodes?.length ? <TagFootNote tags={tags} /> : null}
          </FlexCol>
        </FlexRow>
      </InternalFlexGrid>
      {relatedContent?.pages ? (
        <RelatedPages relatedContent={relatedContent} />
      ) : null}
    </InternalPageContainer>
  )
}

export default InternalPage
